import React, {useContext, useEffect, useRef, useState} from 'react';
import JobListViewContext, { RightClickContext } from '../common/JobListViewContext';
import { getJobNameByTbName, JobNames } from '../../framework.core/JobNames';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../ui/ActionButton';
import ToolboxMenuItem from '../../uiControls/ToolboxMenuItem';
import ListViewShortcutMenu from '../common/ListViewShortcutMenu';
import useFunctionKeys from '../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../uiControls/infoArea/InfoAreaDrawer';
import AbstractListView, { DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer } from '../common/AbstractListView';
import { Search } from '../../filtering';
import constants from '../../constants';
import { DateRenderer, DateTimeRenderer, TextAlignLeftRenderer, TextRenderer } from '../../uiControls/SmartTableRenderers';
import { TableColumn, TableSettings, taskList } from '../../tableSettings';
import JobListSuntekCommand from '../common/JobListSuntekCommand';
import * as XCol from '../../framework.core/XExportColumn';
import Menu, { IfmsMenuItem } from '../../ui/menu/Menu';
import { MemoOpTypeRenderer } from '../common/commonListRenderers';
import { useHistory } from 'react-router';
import { NavigationType, openNewPage } from '../../util/navigationHelpers';
import { MTTaskListItem } from '../../fms.data/models/MTTaskListItem';
import taskReminderRedIcon from '../../img/pin_red.svg';
import taskReminderGreenIcon from '../../img/pin_green.svg';
import ApplicationContext from '../../ApplicationContext';
import useExternalScreenFilter from '../../hooks/useExternalScreenFilter';
import { SearchModelBase } from '../../fms.data/models/SearchModelBase';
import { appendLine, findSecurityTask, getDetailSecLinkInfo, getJobNameBySourceType, getListUrlWithSecCheck, getOredrByJobName } from '../../util';
import useGlobalOkDialog from '../../hooks/useGlobalOkDialog';
import { useSecureNavigate } from '../../hooks/useSecureNavigate';
import { getFmsGlobal } from '../../globals';
import gpsIcon from '../../img/cntr-tracking-rq-12-green.svg';
import taskReminderDarkBlueIcon from '../../img/pin_darkblue.svg';
import PrimaryButton from '../../ui/PrimaryButton';
import styled from 'styled-components';
import postal from 'postal';
import excelImg from '../../img/memo_doc_excel.svg';
import pdfImg from '../../img/memo_doc_pdf.svg';
import pptImg from '../../img/memo_doc_ppt.svg';
import textImg from '../../img/memo_doc_text.svg';
import wordImg from '../../img/memo_doc_word.svg';
import msgImg from '../../img/memo_doc_msg.png';
import pngImg from '../../img/memo_doc_png.svg';
import config from '../../config';
import GrayButtonTabs from '../../ui/GrayButtonTabs';
import PrimaryButtonTabs from '../../ui/PrimaryButtonTabs';
import DeepBlueButtonTabs from '../../ui/DeepBlueButtonTabs';
import MultilineTextBox from '../../ui/MultilineTextBox';
import CommentTable from '../common/CommentTable';
import FilterableSelect2 from '../../ui/FilterableSelect2';
import { useDropzone } from 'react-dropzone';
import InlineInputControlRowNoLabel from '../../ui/layout/InlineInputControlRowNoLabel';
import InlineInputControlRow from '../../ui/layout/InlineInputControlRow';
import Label from '../../ui/Label';
import RadioButton from '../../ui/RadioButton';
import DateTime from '../../ui/DateTime';
import { formatDateTimeFull, now } from '../../dateUtils';
import UsersDropDown from '../../uiControls/UsersDropDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faUpload } from '@fortawesome/free-solid-svg-icons';
import { Memo } from '../../framework.core/Memo';
import { useTypedFastStorage } from '../../hooks/useFastStorage';
import useSuntekSettings from '../../hooks/useSuntekSettings';
import _, { isEmpty } from 'lodash';
import IfmsModal from '../../ui/IfmsModal';
import SecondaryButton from '../../ui/SecondaryButton';
import useSystemSettings from '../../hooks/useSystemSettings';
import { CodeMemoTitleListItem } from '../../fms.data/models/CodeMemoTitleListItem';
import { showGlobalOkDialog } from '../../features/globalOkDialogSlice';
import { SQLField, SQLInfo, SQLType } from '../../framework.core/data/SQLInfo';
import { checkPropDirty, getSQLInfoList } from '../../fms.core/data/TrackingModule';
import { ApiResult, InsertResultsWithData } from '../../framework.core/data/ApiResult';
import { useReminderContext } from '../../ReminderContext';
import { TrackableEntity } from '../../fms.core/data/ChangeTrackable';
import { FmsSecTask } from '../../fms.core/constants';
import useGlobalYesNoDialog from '../../hooks/useGlobalYesNoDialog';
import { AddIconButton2, DeleteIconButton2, EditIconButton2, ViewIconButton2 } from '../../ui/IconButton';
import useDirtyCheck from '../../hooks/useDirtyCheck2';
import useSetEditedId from '../../hooks/useSetEditedId';
import { invalidateTaskBoard } from '../common/TaskDashBoard';

// 250801.inhyung.Issue#2591 Task List에 New, Edit, View, Delete 기능 추가.
class AttachFile {
  logId: number;
  logFileId: number;
  file: File;

  constructor(init?:Partial<AttachFile>) {
    // super();
    this.logId = 0;
    this.logFileId = 0;
    this.file = new File([],"");

    Object.assign(this, init);
  };
}

const channel = postal.channel('ajax');

const MemoDropzoneContainer = styled.div`
  border: 1px solid #e5e5e5;
  height: 130px;
  background-color: #f8fafb;
  overflow-y: auto;

  h3 {
    margin-top: 15px;
    color: #767373;
    text-align: center;
    font-size: 22px;
  }
  h4 {
    color: #767373;
    text-align: center;
    font-size: 18px;
  }

  .upload-icon {
    color: #e5e5e5;
    text-align: center;
    font-size: 36px;
  }
`;

async function openLogFile(logFileId: number, logFileName: string, userToken: string) {
  if (logFileId <= 0 || !logFileName) return;

  try {
    const response = await fetch(`${config.serverUrl}memo/openLogFile?logFileId=${logFileId}&logFileName=${logFileName}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${userToken}`
      }
    });

    if (response.ok) {
      const contentType = response.headers.get('content-type');

       //pdf
      if (contentType && contentType.toLowerCase().includes('application/pdf')) {
        const pdfBlob = await response.blob();
        const newWindow = window.open('', '_blank');

        if (newWindow) {
          const pdfUrl = URL.createObjectURL(pdfBlob);

          const iframe = document.createElement('iframe');
          iframe.src = pdfUrl;
          iframe.width = '100%';
          iframe.height = '100%';

          newWindow.document.body.style.margin = '0';
          newWindow.document.body.style.overflow = 'hidden';
          newWindow.document.title = logFileName;
          newWindow.document.body.appendChild(iframe);
        } else {
          console.error('error');
        }
      } else {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = logFileName;
        a.click();
      }
    } else {
      console.error('error', response.status);
    }
  } catch (error) {
    console.error('error', error);
  }
}

type MemoMode = 'new' | 'edit' | 'view';

function getFileIcon(filename: string)
{
  if (filename) {
    if (filename.indexOf('.pdf') >= 0) return pdfImg
    if (filename.indexOf('.xls') >= 0) return excelImg
    if (filename.indexOf('.xlsx') >= 0) return excelImg
    if (filename.indexOf('.doc') >= 0) return wordImg
    if (filename.indexOf('.docx') >= 0) return wordImg
    if (filename.indexOf('.ppt') >= 0) return pptImg
    if (filename.indexOf('.pptx') >= 0) return pptImg
    if (filename.indexOf('.msg') >= 0) return msgImg
    if (filename.indexOf('.png') >= 0) return pngImg
  }
  return textImg
}

function MemoDetails({ memo, setMemo, memoTitle, files, setFiles, jobName, jobId, isViewMode }: {
  memo: Memo,
  setMemo: (change: Partial<Memo>) => void,
  memoTitle: any,
  files: Array<any>,
  setFiles: (change: Partial<Array<any>>) => void,
  jobName: string,
  jobId: number,
  isViewMode: boolean
}) {
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [tabIndex, setTabIndex, //removeTabIndexFromStorage
  ] = useTypedFastStorage<number>('0');  
  const suntekSettings = useSuntekSettings();
  const [useReminder, setUseReminder] = useState<boolean>(false);
  useEffect(() => {
    //if (memo && memo.id <= 0 && !memo.title) setMemo({ title: "" });
    setUseReminder(memo.addAsTaskReminder);
    setTabIndex(memo.addAsTaskReminder ? 1 : 0);

    // <chuck date="2025-08-18" ticket="250810101" desc="Set Default Focus to Title">
    const focusElement = document.getElementById('memo-log-subject');
    if (focusElement) {
      focusElement.focus();
    }
    // </chuck>
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);


  function onChange(change: Partial<Memo>) {
    setMemo(change);
  }

  async function odFileDrop(acceptedFiles: any[]) {
    const oriFiles = [...files];
    let duplicateFileName = '';

    for (let i = 0; i < oriFiles.length; i++) {
      for (let j = 0; j < acceptedFiles.length; j++) {
        if (oriFiles[i].file.name === acceptedFiles[j].name
          && oriFiles[i].file.size === acceptedFiles[j].size
          && oriFiles[i].file.lastModifiedDate.toString() === acceptedFiles[j].lastModifiedDate.toString()) {
          duplicateFileName = appendLine(duplicateFileName, acceptedFiles[j].name);
          //acceptedFiles = acceptedFiles.filter(x => (x.name !== acceptedFiles[j].name));
          acceptedFiles.splice(j,1);
          break;
        }
      }
    }

    for (let i = 0; i < acceptedFiles.length; i++) {
      if(acceptedFiles[i].size > 0 && acceptedFiles[i].size > (suntekSettings.accounting?.memoAttachedFileMaxSize??5000)*1000000){
        await showGlobalOkDialog(<p>{acceptedFiles[i].name} is larger than {suntekSettings.accounting?.memoAttachedFileMaxSize}MB</p>);
      }else if(acceptedFiles[i].size > 0){
        const newFile: AttachFile = new AttachFile({ logId: 0, logFileId: 0, file: acceptedFiles[i] });
        oriFiles.push(newFile);
      }else{
        await showGlobalOkDialog(<p>{acceptedFiles[i].name} is a Null File, Please Check it again!</p>);
      }
    }

    setFiles(oriFiles);

    if (!_.isEmpty(duplicateFileName))
      await showGlobalOkDialog(<p>Duplicate file is not attached<br />
        {duplicateFileName}
      </p>);
  }

  function deleteFile(e:any, i:number) {
    const newFiles = [...files];
    newFiles.splice(i, 1);

    setFiles(newFiles);

    e.preventDefault();
    e.stopPropagation();
  }

  async function openFile(e:any, i:number)
  {
    e.preventDefault();
    e.stopPropagation();

    const logFileId = files[i].logFileId;
    const logFileName = files[i].file.name;
    const userToken = appContext.user ? appContext.user.accessToken ?? '' : '';

    openLogFile(logFileId, logFileName, userToken);
  }

  function renderDetails() {
    if (tabIndex === 0) {
      return <div {...getRootProps({ disabled: isViewMode })}>
        <MemoDropzoneContainer>
          <div id='memo-log-accepted-files' className="accepted-files">
            {files.map((f, i) =>
              <div key={i} className="accepted-file">
                &nbsp;
                <button id={"AttachDelete" + i} className="ifms-black-inverse-button" onClick={e => deleteFile(e, i)} disabled = {isViewMode} style={{ color: 'Red', padding: 0 }}>
                  <FontAwesomeIcon style={{ fontSize: '15px' }} icon={faTimes} data-tooltip="Open" />
                </button>
                &nbsp;
                {f.logId > 0
                  ?
                  <button id={"AttachOpen" + i} className="ifms-black-inverse-button" onClick={e => openFile(e, i)} style={{ padding: 0, paddingBottom: '2px' }}>
                    <img id={"AttachOpen" + i + "-img"} src={getFileIcon(f.file.name)} style={{ width: '17px', height: '17px' }} alt="" />
                  </button>
                  :
                  ''
                }
                &nbsp;
                {f.file.name}
              </div>
            )}
          </div>
          <input  disabled={isViewMode}  id='memo-log-dropFile' {...getInputProps()} />
          <h3>Drop files here (or click)</h3>
          <p className="upload-icon"><FontAwesomeIcon icon={faUpload} /></p>
        </MemoDropzoneContainer>
      </div>;
    }
    if (tabIndex === 1) {
      memo.operator = ((memo.operator === '' ? (appContext.user?.isSuntekAdmin ? '' : (appContext.user ? appContext.user.id ?? '' : '') ) : memo.operator));
      memo.remind = ((memo.remind === null||memo.remind === '') ? now() : memo.remind);
      
      
      return <div style={{ height: '130px', paddingTop: '5px', paddingLeft: '30px' }}>
        <InlineInputControlRow mode="w150" label="Assign To" alignRight>
          <div style={{width:'100px'}}>
              <UsersDropDown
                name='oih-detail-preparedBy'
                value={memo.operator}                
                disabled = {isViewMode}
                onChange={userId => {setMemo({operator : userId})}}
              />
          </div>

        </InlineInputControlRow>

        <InlineInputControlRow mode="w150" label="Reminder Date & Time" alignRight>
          <div style={{ width: '130px', marginBottom:'16px' }}>
            <DateTime dateId="memo-due" timeId='memo-time' value={memo.due} hideIcon={false} disabled={isViewMode}
              onChange={due => {
                setMemo({due: due});         
              }}
            /></div> 
        </InlineInputControlRow>
        <div style={{marginTop: '20px'}} />
        <InlineInputControlRow mode="w150" label="Status" alignRight>
          <div style={{ display: 'flex'}}>
            <div style={{ width: '100px' }}>
              <RadioButton group="status" reverse label="Open"
                checked={memo.reminderStatus === 1}
                disabled = {isViewMode}
                onChecked={(e) => { setMemo({reminderStatus : 1})}} /></div>
            <RadioButton group="status" reverse label="Done"
              checked={memo.reminderStatus === 0}
              disabled = {isViewMode}
              onChecked={(e) => {setMemo({reminderStatus : 0}) }} /></div>
        </InlineInputControlRow>
        <div style={{marginTop: '30px'}} />
        <div style={{textAlign: 'right'}}>
          <div style={{display:'inline-block'}}>
          <InlineInputControlRowNoLabel>
            <Label name='last-update' style={{color:'black'}} label={`${formatDateTimeFull(memo.createdAt, suntekSettings.company?.dateFormat.toUpperCase() ?? '', true)}  ${memo.createdBy}`} />
          </InlineInputControlRowNoLabel>          
          </div>
        </div>
      </div>;
    }

    return null;
  }
  const { getRootProps, getInputProps } = useDropzone({ onDrop: odFileDrop })

  return (
    <div>
      <div>Title</div>
      <FilterableSelect2
        name='memo-log-subject'
        selectId='memo-log-subject'
        placeholder=' Input your free title here.'
        getId={(x, i) => `${i}-${x}`}
        getLabel={x => x}
        onSelect={title => {onChange({ title });
        }}
        onTextChange={title => onChange({ title })}
        items={memoTitle.map((x:any) => x.title)}
        initialValue={memo?.title ?? ""}
        maxLength={50}
        disabled={isViewMode}
      />
      <div style={{ height: '10px' }}>&nbsp;</div>

      <div>Task / Memo</div>
      <MultilineTextBox name='memo-log-memo' value={memo?.description ?? ''} onChange={e => onChange({ description: e.target.value ?? '' })} disabled = {isViewMode} style={{ height: '150px' }} />


      {/*Comment Table 추가*/}
      <div>Comment</div>
      <CommentTable memo={memo} isViewMode={isViewMode} onChange={onChange}  />

      <div style={{ height: '30px', display: 'flex', paddingTop: '7px' }}>
        {/* <CheckBox label='Public' value={memo.isPublic} onChange={(e) => {setMemo({isPublic : e, memoType: e ? 'C' : ''})}} disabled = {isViewMode} /> */}
        <div style={{ width: '330px' }}></div>
        {/*Task Board에서 팝업창을 Open 할때는 Task Reminder CheckBox Hide */}
        {/*<CheckBox label='Task Reminder' value={memo.addAsTaskReminder} onChange={(e) => {setMemo({addAsTaskReminder : e}); setUseReminder(e) ; setTabIndex(e === true ? 1 : 0);}} disabled = {isViewMode} />*/}
      </div>
      <div className="" style={{ borderBottom: '2px solid #0F79FF', padding: '0px 20px', margin: '0 0 10px 0' }}>
        {renderTitleButton(<span>Attached File(s)</span>, tabIndex === 0, () => setTabIndex(0), appContext.useDarkMode)}
        {useReminder && renderTitleButton(<span>Task Reminder</span>, tabIndex === 1, () => setTabIndex(1), appContext.useDarkMode)}
      </div>
      {renderDetails()}
    </div>
  );
}

function renderTitleButton(label: React.ReactNode | string | null | undefined, selected: boolean, onClick: VoidFunction, useDarkMode: boolean) {
  const Button = !selected ? GrayButtonTabs : !useDarkMode ? PrimaryButtonTabs : DeepBlueButtonTabs;

  return <Button size='regular' onClick={onClick}>{label}</Button>
}



function useMemoAllOperations(){
  const history = useHistory();
  const {setFilterForScreenExternally} = useExternalScreenFilter();
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const secureNavigate = useSecureNavigate();
  const jobListContext = useContext(JobListViewContext);
  
  function showMemoDetail(id: number){
      appContext.setAppInfoAreaContent('memo');
      appContext.setMyMemoId(id);
  }

  function switchToOp(memo: MTTaskListItem|null){
    if (!memo){
      return;
    }

    const jobName = getJobNameBySourceType(memo.opType);
    const isContainerJob = [JobNames.OIContainer,JobNames.OEContainer,JobNames.OtherContainer].includes(jobName);
   
    if(isContainerJob){
      const columnId = [JobNames.OIContainer, JobNames.OEContainer].includes(jobName) ? 'containerId': 'id';
      const listUrl = getListUrlWithSecCheck(appContext, jobName, showGlobalOkDialog);
      if (!listUrl) return;
      const orderBy = getOredrByJobName(jobName);
      showMemoDetail(memo.id??0);
      setFilterForScreenExternally(listUrl, columnId, '', memo.tbId.toString(), orderBy, false, true,({...new SearchModelBase()} as SearchModelBase));  // Update version);
      openNewPage(history, listUrl, NavigationType.newPage);
      
    } else {
        const {secTask, detailUrl } = getDetailSecLinkInfo(jobName, memo.tbId, memo.bltbId, memo.bltbName);
        if (!secTask || !detailUrl) return;

      showMemoDetail(memo.id??0);
      
      secureNavigate(secTask, () =>
        jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(detailUrl, [detailUrl, detailUrl.replace('/view', '/edit')])
      );
    }
  }

  return {switchToOp};

}

function  RefNoRenderer({cell, row, data}: any){
    const {switchToOp} = useMemoAllOperations();

  if(!cell.value){
    return <div className="ifms-table-align-left">{cell.value}</div>;
  }

  return <div className='ifms-table-align-left' onClick={() => switchToOp(data[row.index])} style={{width: '100%', lineHeight:'1em', color: 'blue', cursor:'pointer'}}>{cell.value}</div>
}

function TaskStatusRenderer({ data, row }: any) {
  
  const fmsGlobal = getFmsGlobal();
  function openContainerTracking() {
    const l = data[row.index];
    let blNo = `mbl=${l.refNo}`;
    if(['OIH','OEH'].includes(l.opType)){
      blNo = `hbl=${l.refNo}`;
    }
    else if (l.opType === 'OTH'){
      blNo = `search=${l.mblNo}`;
    } 
      window.open(`https://trackinginfo.suntekscm.com/?licid=${fmsGlobal.AcmeID}&${blNo}`);
  }


  const l = data[row.index];
  const lStatus = (l as any).taskStatus as string;
  let dataTooltip = lStatus;
  let content: React.ReactNode = <></>;
  if(lStatus === 'Pending') 
    content = <img height="14px" src={taskReminderDarkBlueIcon} id={'redpinIcon'} style={{ position: 'relative', top: '0px' }} alt=""/>;
  else if (lStatus === 'Done')
    content = <img height="14px" src={taskReminderGreenIcon} id={'greenpinIcon'} style={{ position: 'relative', top: '0px' }} alt=""/>;
  else content = <img height="14px" src={gpsIcon} id={'gpsIcon'} onClick={openContainerTracking} alt=""/>;
  return (
  <div className="ifms-table-default" id="taskStatus_renderer" data-tooltip={dataTooltip} style={{ width: '100%'}} >{content}</div>
);

}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const jobListContext = useContext(JobListViewContext);

  const items = [
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Refresh', shortcut: 'F11', separator: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    index,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        jobListContext.triggerTableSearch('F5');
        break;
      case 1:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ListCommands() {
  const history = useHistory();
  const [editMemo, setEditMemo, removeEditMemo, ] = useTypedFastStorage<Memo>(`ifms-memo-editable`, null);
  const [memoMode, setMemoMode] = useState<MemoMode>('view');
  const [files, setFiles] = useState<Array<any>>([]);
  const startFiles = useRef<Array<any>>([]);
  const [memoTitle, setMemoTitle] = useState<Array<any>>([]);
  const isViewMode = memoMode === 'view';
  const systemSettings = useSystemSettings();
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { refreshReminderStatus, refreshReminderCount } = useReminderContext();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [loading, setLoading] = useState(false);

  const taskListSec = findSecurityTask(appContext, FmsSecTask.TaskList);
  const canBeRead = taskListSec.grantRead;
  const canBeDeleted = taskListSec.grantDel && taskListSec.grantRead
  const canBeEdit = taskListSec.grantEdit && taskListSec.grantRead;
  const canBeAdd = taskListSec.grantAdd && taskListSec.grantRead;
  const {setCleanState} = useDirtyCheck(`ifms-memo-editable`,['modifiedAt', 'modifiedBy']);
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as MTTaskListItem;

  //Task에 변경사항 있을때 연결된 B/L List 갱신
  const setSavedEntityOIM = useSetEditedId([JobNames.OIMbl]);
  const setSavedEntityOIH = useSetEditedId([JobNames.OIHbl]);
  const setSavedEntityOEM = useSetEditedId([JobNames.OEMbl]);
  const setSavedEntityOEH = useSetEditedId([JobNames.OEHbl]);
  const setSavedEntityAIM = useSetEditedId([JobNames.AIMbl]);
  const setSavedEntityAIH = useSetEditedId([JobNames.AIHbl]);
  const setSavedEntityAOM = useSetEditedId([JobNames.AEMbl]);
  const setSavedEntityAOH = useSetEditedId([JobNames.AEHbl]);
  const setSavedEntityOT = useSetEditedId([JobNames.OtherOP]);
  const setSavedEntityTASK = useSetEditedId([JobNames.TaskList]);
  
  useEffect(() => {
    loadMemoTitle();
  }, []);

  async function refreshReminder(){
    await refreshReminderStatus(); //reminder Timer로 체크 필요
    await refreshReminderCount(); // 삭제 시 Task Count 계산 필요
    //await reload();
  }
  

  async function loadMemoTitle() {
      const search = {
        orderBy: 'code',
        orderByAscending: true,
        pageSize: systemSettings.defaultPageSize
      } as Search;

      const apiResult = await appContext.api.getListItems(JobNames.MemoTitle, 
        'CodeMemoTitleListItem',
        CodeMemoTitleListItem.calculateSearchParameters(search),
        1,
        search.pageSize
        );
      if (apiResult?.entities && apiResult?.totalCount > 0) {
        const nonEmptyTitles = apiResult.entities.filter((x:any) => !!x.description && !x.inactive).map((x:any) => ({title: x.description, isDefault: x.isDefault, isTask: x.isTask}));
        if ( nonEmptyTitles.length > 0) {
          setMemoTitle(nonEmptyTitles);
        }
      }else {
        setMemoTitle([]);
      }
  }

  function onMemoPopupClose(){
    removeEditMemo();
  }

  async function saveMemoData(memo:any) : Promise<any>{

    if(isEmpty(memo.title)){
      await showGlobalOkDialog(`Please input the Memo Title`);
      return false;
    }

    if (memo.addAsTaskReminder) {
      if(!memo.operator){
        await showGlobalOkDialog(`Please Select a Assign to.`);
        return false;
      }
      if(!memo.due){
        await showGlobalOkDialog(`Please Set the Remind Date.`);
        return false;
      }
    }

    channel.publish('ajax.loadingstart', {});
    
    setLoading(true);

    const userId = appContext.user ? appContext.user.id ?? '' : '';
    const mainChange: Partial<Memo> = {};
    const currentTime = now();
    if (memo.id <= 0){
      mainChange.createdBy = userId;
      mainChange.createdAt = currentTime;
    } 
    mainChange.modifiedBy = userId; 
    mainChange.modifiedAt = currentTime; //dirty 발생

    //Comment가 공백인 Row를 지움
    if(memo.commentList.length > 0){
      setEditMemo({commentList: memo.commentList.filter((x: any) => x.comment)});
    }

    //Comment Table에서 변경된 Row의 Update Date, Update By 갱신
    const updateComments = memo.changedCollectionProps.find((x: any) => x.collectionName === 'commentList');
    if(updateComments && updateComments.changedItems.length > 0){
      const updateCommentIds = updateComments.changedItems.map((x: any) => x.changeTrackable.id);
      memo.commentList.forEach((x: any) => {
          if(updateCommentIds.includes(x.id)){
            x.u2Date = currentTime;
            x.u2ID = userId;
          }
      })
      setEditMemo({commentList: memo.commentList});
    }

    //Comment Index 갱신 (Save 시점에서)
    if(memo.commentList.length > 0){
        let index = 1;
        memo.commentList.forEach((x: any) => {
          x.commentTitle = `Comment ${index}`;
          index++;
      });
      setEditMemo({commentList: memo.commentList});
    }

    if (!_.isEmpty(mainChange)) {
      setEditMemo(mainChange);
    }
    
    const sqlInfoList = getSQLInfoList(memo as TrackableEntity);

    // Check Attach Files
    let i: number, k: number;
    const deletedFiles:Array<any> = [];

    if (startFiles?.current) {
      for (i = 0; i < startFiles.current.length; i++) {
        for (k = 0; k < files.length; k++) {
          if (startFiles.current[i].logId === files[k].logId && startFiles.current[i].file.name === files[k].file.name) break;          
        }
        if (k < files.length) files.splice(k, 1);
        else deletedFiles.push(startFiles.current[i]);
      }
    }
    const addedFiles: Array<any> = [...files];

    deletedFiles.map((delFile, index) => {
      sqlInfoList.push(new SQLInfo({
        tableName: "T_NLOGFILE",
        type: SQLType.Delete,
        where: `F_Idex = (select F_LogFileID from T_NLogMain where F_Idex=${delFile.logId ?? 0})`
      }));
      sqlInfoList.push(new SQLInfo({
        tableName: "T_NLOGMAIN",
        type: SQLType.Delete,
        key: new SQLField({ fieldName: "F_Idex", propertyName: "idex", value: delFile.logId ?? 0 }),
      }));
      return delFile;
    });

    const reminderSql: SQLInfo[] = [];
    if (checkPropDirty(memo, 'addAsTaskReminder')) {
      if (memo.addAsTaskReminder) {
        reminderSql.push(new SQLInfo({
          tableName: "T_AOTHERINFO",
          type: SQLType.Insert,
          fields: [
            new SQLField({ fieldName: "F_C1", propertyName: "C1", value: memo.operator }),
            new SQLField({ fieldName: "F_C2", propertyName: "C2", value: memo.operator }),
            new SQLField({ fieldName: "F_D1", propertyName: "D1", value: memo.remind }),
            new SQLField({ fieldName: "F_D2", propertyName: "D2", value: memo.due }),
            new SQLField({ fieldName: "F_N1", propertyName: "N1", value: memo.addAsTaskReminder }),
            new SQLField({ fieldName: "F_N2", propertyName: "N2", value: memo.reminderStatus }),
          ],
          whereFields: [
            new SQLField({ fieldName: 'f_tbname', propertyName: 'TbName', value: 'T_MEMO' }),
            new SQLField({ fieldName: 'f_tbid', propertyName: 'TbId', value: memo.id }),
            new SQLField({ fieldName: 'f_type', propertyName: 'Type', value: 0 })
          ]
        }));
      } else {
        reminderSql.push(new SQLInfo({
          tableName: "T_AOTHERINFO",
          type: SQLType.Delete,
          whereFields: [
            new SQLField({ fieldName: 'f_tbname', propertyName: 'TbName', value: 'T_MEMO' }),
            new SQLField({ fieldName: 'f_tbid', propertyName: 'TbId', value: memo.id }),
            new SQLField({ fieldName: 'f_type', propertyName: 'Type', value: 0 })
          ]
        }));
      }
    } else if (memo.addAsTaskReminder) {
      reminderSql.push(new SQLInfo({
        tableName: "T_AOTHERINFO",
        type: SQLType.Update,
        fields: [
          new SQLField({ fieldName: "F_C1", propertyName: "C1", value: memo.operator }),
          new SQLField({ fieldName: "F_C2", propertyName: "C2", value: memo.creator }),
          new SQLField({ fieldName: "F_D1", propertyName: "D1", value: memo.remind }),
          new SQLField({ fieldName: "F_D2", propertyName: "D2", value: memo.due }),
          new SQLField({ fieldName: "F_N1", propertyName: "N1", value: memo.addAsTaskReminder }),
          new SQLField({ fieldName: "F_N2", propertyName: "N2", value: memo.reminderStatus }),
        ],
        whereFields: [
          new SQLField({ fieldName: 'f_tbname', propertyName: 'TbName', value: 'T_MEMO' }),
          new SQLField({ fieldName: 'f_tbid', propertyName: 'TbId', value: memo.id }),
          new SQLField({ fieldName: 'f_type', propertyName: 'Type', value: 0 })
        ]
      }));
    }

    sqlInfoList.push(...reminderSql);
    const apiResult: ApiResult<InsertResultsWithData> = await appContext.api.saveJobDetail(JobNames.Memo, sqlInfoList, {});

    const insertResult = apiResult?.result?.insertList.find(x => x.model === 'Memo');
    const savedId = insertResult?.newId ?? memo.id;

    if (apiResult && apiResult.success) {
      // Added Files
      const formData = new FormData();
      for (let i = 0; i < addedFiles.length; i++) {
        formData.append("file", addedFiles[i].file);
      }
      formData.append("memoId", '' + savedId);
      formData.append("jobName", '' + memo.jobName);
      formData.append("memoType", 'D');
      if (memo.addAsTaskReminder) {
        //Task Reminder가 활성화되어있고, Reminder 관련 Dirty 발생시
        if (checkPropDirty(memo, 'operator')|| checkPropDirty(memo,'creator')||checkPropDirty(memo,'remind') ||checkPropDirty(memo,'due') || checkPropDirty(memo,'reminderStatus') || checkPropDirty(memo, 'addAsTaskReminder')) {
          //appContext.setUseCheckReminder(!appContext.useCheckReminder);
          await refreshReminderStatus(); // reminderTimer가 실행되지 않은 경우 반복 실행 필요
          await refreshReminderCount();  // 저장시 Task Count 계산 필요

         //INV/Bill/CRDB Memo는 연결된 B/L List를 업데이트
          const targetTbName = memo.bltbName ?? memo.tbName;
          const targetTbId = memo.bltbId ?? memo.tbId;
          setRelatedListEntity(targetTbName, targetTbId); //B/L List 갱신
          invalidateTaskBoard();
        } 
      }

      const apiResult2: ApiResult<InsertResultsWithData> = await appContext.api.upload(formData);
      if (apiResult2 && apiResult2.success) {
      }


    } else {
      await showGlobalOkDialog(`Failed to save : ${apiResult?.message}`);
      return false;
    }

    setLoading(false);
    //appContext.setOpenMemoDetail(false);
    //appContext.setMyMemoTaskReminder(false);
    //appContext.setMyMemoId(0);

    channel.publish('ajax.loadingend', {});

    setSavedEntityTASK(savedId.toString(), memoMode === 'new');
    return true;
  }

  const beforeClose =
   (memoMode === 'edit' || memoMode === 'new') ?
    <SecondaryButton name='memo-log-header-save-button' size="extrasmall" focusable={true} onClick={saveMemo}>
      SAVE
    </SecondaryButton> : undefined;
  
  async function saveMemo() {
    const result = await saveMemoData(editMemo);
    if (result) {
      removeEditMemo();
    }
  }

  function goToHome() {
    openNewPage(history, '/home/home', NavigationType.newPage);
  }

  async function confirmDelete(): Promise<boolean>{
    return await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    , false, 0, true, 'warning');
  }

    function setRelatedListEntity(tbName: string, tbId: number) {

    switch(tbName){
      case "T_OIMMAIN":
        setSavedEntityOIM(tbId.toString(), false, false);
        break;
      case "T_OIHMAIN":
        setSavedEntityOIH(tbId.toString(), false, false);
        break;
      case "T_OOMMAIN":
        setSavedEntityOEM(tbId.toString(), false, false);
        break;
      case "T_OOHMAIN":
        setSavedEntityOEH(tbId.toString(), false, false);
        break;
      case "T_AIMMAIN":
        setSavedEntityAIM(tbId.toString(), false, false);
        break;
      case "T_AIHMAIN":
        setSavedEntityAIH(tbId.toString(), false, false);
        break;  
      case "T_AOMMAIN":
        setSavedEntityAOM(tbId.toString(), false, false);
        break;
      case "T_AOHMAIN":
        setSavedEntityAOH(tbId.toString(), false, false);
        break;
      case "T_GENMAIN":
        setSavedEntityOT(tbId.toString(), false, false);
        break;
      default:
        break;
    }
  }

  async function deleteMemo(selectElement: MTTaskListItem){
    if(!selectElement) return;
    if (!(await confirmDelete())) return;

    const apiResult = await appContext.api.deleteJobDetail(JobNames.Memo, { id: selectElement.id });
    if (apiResult && !apiResult.success) {
      const message = apiResult?.message ?? 'Cannot delete!';
      await showGlobalOkDialog(message);
      return;
    }

    //INV/Bill/CRDB Memo는 연결된 B/L List를 업데이트
    const targetTbName = selectElement.bltbName ?? selectElement.tbName;
    const targetTbId = selectElement.bltbId ?? selectElement.jobId;
    setRelatedListEntity(targetTbName, targetTbId); //B/L List 갱신

    removeEditMemo();
    onMemoPopupClose();
    await refreshReminder();
    invalidateTaskBoard();
    jobListContext.reloadData();
  }


  async function deleteMemoFromDetail(){
    if (!editMemo?.id) return;
    if (!(await confirmDelete())) return;

    const apiResult = await appContext.api.deleteJobDetail(JobNames.Memo, { id: editMemo.id });
    if (apiResult && !apiResult.success) {
      const message = apiResult?.message ?? 'Cannot delete!';
      await showGlobalOkDialog(message);
      return;
    }

    //INV/Bill/CRDB Memo는 연결된 B/L List를 업데이트
    const targetTbName = editMemo.bltbName ?? editMemo.tbName;
    const targetTbId = editMemo.bltbId ?? editMemo.jobId;
    setRelatedListEntity(targetTbName, targetTbId); //B/L List 갱신

    removeEditMemo();
    onMemoPopupClose();
    await refreshReminder();
    invalidateTaskBoard();
    jobListContext.reloadData();
  }

  async function setMemoDetailView(selectElement: MTTaskListItem){
    await setMemoDetail(selectElement, true);
  }


  async function setMemoDetail(selectElement: MTTaskListItem|null, isView: boolean){

    if(selectElement && _.isEmpty(editMemo)){
      const jobId = selectElement.tbId;
      const jobName = getJobNameByTbName(selectElement.tbName);
      const bltbName = selectElement.bltbName;
      const bltbId = selectElement.bltbId;
      const apiResult: ApiResult<Memo> = await appContext.api.getJobDetail(JobNames.Memo, { id: selectElement.id});
      if (!apiResult || !apiResult.success) 
        {
        await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>);
         return null;
        } 
      else {
        const obj = { ...apiResult.result, jobId: jobId, jobName: jobName, edit: true, view: isView, bltbName: bltbName, bltbId: bltbId };
        const tEntity = new Memo(obj);
        setCleanState(new Memo(_.cloneDeep(tEntity)));
        setMemoMode(isView ? 'view': 'edit');
        tEntity.trackable = true;
          // LogDetails --> files
        const newfiles:Array<any> = [];
        tEntity.logFileDetails.map((logFile, index) => {
          const file = new AttachFile({
          logId: logFile.id,
          logFileId: logFile.logFileId,
          file: new File([], logFile.oFileName),
        });

           newfiles.push(file);
           return logFile;
         });
        setFiles(newfiles);
        const starts:Array<any> = [...newfiles]
        startFiles.current = starts;
        setEditMemo(tEntity);
       }
    } else {
      const tEntity2 = new Memo();
      tEntity2.tbName = "General";
      tEntity2.jobName = "General";
      tEntity2.jobId = 0;
      tEntity2.addAsTaskReminder = true;
      setCleanState(tEntity2);
      setEditMemo(tEntity2);
      setMemoMode('new');
      tEntity2.trackable = true;

      const files:Array<any> = [];
      setFiles(files);
      const starts:Array<any> = [...files]
      startFiles.current = starts;
    }
  }  
  return (
    <div className='ifms-common-no-vertical-separator-gap-margin'>
      <div className='ifms-common-vertical-gap-separator'>
        <PrimaryButton name = 'mt-go-to-home-button' size={"extrasmall"} onClick={goToHome}>← Home</PrimaryButton>
{jobListContext.f6Query && (
   <span style={{ marginLeft: 8, padding: '0px 8px', fontSize: 12, border: '1px solid #5bc0de', borderRadius: 4, whiteSpace: 'nowrap', color: appContext.useDarkMode ? 'white' : 'black', }}>
    Filtered By: {jobListContext.f6Query}
  </span>
)}
      </div>
      <div className='ifms-common-vertical-gap-separator'>
        <AddIconButton2 name='task-board-add-button' disabled={!canBeAdd} onClick={() => { setMemoMode('new'); setMemoDetail(null, false);}} data-tooltip='New'/>
        <EditIconButton2 name='task-board-edit-button' disabled={!canBeEdit} onClick={() => {setMemoMode('edit'); setMemoDetail(selectedElement, false);}} data-tooltip='Edit'/>
        <ViewIconButton2 name='task-board-view-button' disabled={!canBeRead}  onClick={() => {setMemoMode('view'); setMemoDetailView(selectedElement)}} data-tooltip='View'/>
        <DeleteIconButton2 name='task-board-delete-button' disabled={!canBeDeleted} onClick={() => deleteMemo(selectedElement)} data-tooltip='Delete'/>
      </div>
      
    <IfmsModal
        memoCloseOnEsc
        isOpen={!!editMemo}
        isBlueHeader
        title="Task / Memo"
        width='530px'
        draggable
        onCancel={onMemoPopupClose}
        beforeClose={beforeClose}
      >
        <div className='report-popup'>
          <div>
            {!!editMemo &&
              <MemoDetails memo={editMemo} setMemo={setEditMemo} memoTitle={memoTitle} files={files} setFiles={setFiles}  jobName={editMemo.jobName} jobId={editMemo.jobId} isViewMode={isViewMode}/>
            }
          </div>
          <div className="clearfix"></div>
          <div className="report-footer" >
            <SecondaryButton style={{marginLeft:'15px'}} disabled={isViewMode ? !canBeEdit:false} name='memo-log-save-button' size="regular" focusable={true} onClick={() => {
              if (isViewMode) {
                setMemoMode('edit');
              } else {
                saveMemo();
              }
            }}
            >
            { isViewMode ?  'EDIT' :'SAVE'}
            </SecondaryButton>
            
            {(memoMode === 'edit' || memoMode === 'view') && (
              <SecondaryButton name='memo-log-delete-button' size="regular" disabled={!canBeDeleted} focusable={true} onClick={deleteMemoFromDetail}>
                Delete
              </SecondaryButton>)}

            <SecondaryButton name='memo-log-cancel-button' size="regular" focusable={true} onClick={onMemoPopupClose}>
              CLOSE
            </SecondaryButton>
          </div>
        </div>
      </IfmsModal>
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);

  //const {create, edit, view} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F5") {
      jobListContext.triggerTableSearch('F5');
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F5', 'F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.TaskList}
      jobId={(jobListContext.selectedElement as MTTaskListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}



export function useMyTask(){
  const history = useHistory();
  const {setFilterForScreenExternally} = useExternalScreenFilter();

  function switchToMyTask(ids: number[] = [], type: number){
    const safeIds = ids.map(Number).filter(Number.isInteger);

    const searchModel = new MTTaskListItem();
    (searchModel as any).tbId = undefined;   //tbId에서 오류가 나서 강제로 undefined 처리
    // 0건이면 아무것도 안 나오는 조건으로 (IN () 문법 에러 방지)
    searchModel.extraWhere = safeIds.length > 0
      ? `Id in (${safeIds.join(',')})`
      : `1 = 0`;
      
    let text = "";

    switch(type){
      case 1: text = "Pickup Available"; break;
      case 2: text = "Demurrage / LFD Risk"; break;
      case 3: text = "Gate Out / Movement"; break;
      case 4: text = "Detention / Empty Return Risk"; break;
      case 5: text = "ETA Change"; break;
      case 6: text = "Task Memo"; break;
    }

    const listUrl = "/common/joblistview/TASKL/myTask";
    setFilterForScreenExternally(listUrl, '', '', text, '', false, false, searchModel);
    openNewPage(history, listUrl, NavigationType.newPage);
  }

  return {switchToMyTask};
}

/**
 *
 * @class MTTaskListView
 * @extends {AbstractListView}
 */
class MTTaskListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.TaskList,
      'MTTaskListItem',
      MTTaskListItem.calculateSearchParameters(search,MTTaskListItem.MapSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: MTTaskListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.TaskList, 'MTTaskListItem',
      MTTaskListItem.calculateSearchParameters(search, MTTaskListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  MTTaskListItem.formatData(apiResult.entities);
  }
  
  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
        { accessor: 'opType',
        renderer: MemoOpTypeRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
        },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return MTTaskListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.dataIndex === 'refNo') colRenderer.Cell = RefNoRenderer;
      else if (x.dataIndex === 'taskStatus') colRenderer.Cell = TaskStatusRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'taskStatus', changedValue: (value: any)=> { return value['taskStatus'] === 'Pending' ? 'Pending' : 'Done'}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'createdAt',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  taskList;
    const cols = MTTaskListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  
  hasMemo(): boolean {
    return false;
  }
  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: MTTaskListItem) {
    return '';
  }

  getListViewTitle() {
    return 'Task List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.MemoList} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
}

export default MTTaskListView;